import {createContext, use} from 'react'

import type {BoardCardAddress} from '../types'

/**
 * The one thing a card cannot report on its own.
 *
 * Focus and dragging are the board's to see. A dialog is not: a caller draws whatever it
 * likes inside a card, and a menu that opens through a portal is not in the card's subtree
 * at all, so nothing the board could watch would tell it. The card says so instead.
 *
 * Its own context, holding one callback that never changes, so a card reading it never
 * re-renders for it. That is the same rule the contexts in `provider/contexts.ts` follow:
 * split by how often each part changes, and this part does not.
 */
export type BoardDialogReport = {
  reportDialogOpen: (card: BoardCardAddress, isOpen: boolean) => void
}

/** A board whose caller is not listening still answers, so a card can call this unguarded. */
const REPORTS_NOTHING: BoardDialogReport = {reportDialogOpen: () => {}}

export const BoardDialogReportContext = createContext<BoardDialogReport>(REPORTS_NOTHING)

export function useBoardDialogReport(): BoardDialogReport {
  return use(BoardDialogReportContext)
}
